import { createAction, createAsyncThunk } from '@reduxjs/toolkit'

import {
  AutoTransferFundsSteps,
  CurrenciesExchanges,
  PreOrderWithTransfersResponse,
} from '@interfaces'
import {
  AutoTransferWalletOrder,
  AutoTransferWalletPreOrder,
  getAutoWalletTransferOrder,
  getAutoWalletTransferPreOrder,
  getCurrenciesExchanges,
} from '@services'

export const fetchExchangeRates = createAsyncThunk<
  CurrenciesExchanges,
  { target: string }
>('fetchExchangeRates', async ({ target }) => {
  return getCurrenciesExchanges(target)
})

export const getAutoTransferOrder = createAsyncThunk<
  PreOrderWithTransfersResponse,
  AutoTransferWalletOrder
>('getAutoTransferOrder', async (id: AutoTransferWalletOrder) => {
  return getAutoWalletTransferOrder(id)
})

export const getAutoTransferPreOrder = createAsyncThunk<
  PreOrderWithTransfersResponse,
  AutoTransferWalletPreOrder
>(
  'getAutoTransferPreOrder',
  async (walletTransferPreOrdersId: AutoTransferWalletPreOrder) => {
    return getAutoWalletTransferPreOrder(walletTransferPreOrdersId)
  },
)

export const clearExchangeRates = createAction('clearExchangeRates')
export const clearAutoTransferOrders = createAction('clearAutoTransferOrders')
export const clearAutoTransferPreOrders = createAction(
  'clearAutoTransferPreOrders',
)

export const setAutoTransferFundStep = createAction<AutoTransferFundsSteps>(
  'setAutoTransferFundStep',
)

export const goToPrevAutoTranferFundStep = createAction<AutoTransferFundsSteps>(
  'goToPrevAutoTranferFundStep',
)
export const clearAutoTransferFundState = createAction(
  'clearAutoTransferFundState',
)
